<template>
  <div v-if="shouldRender" class="related-items">
    <h4>{{ getContentItem("relatedInvoices") }}</h4>
    <br>
    <p>{{ getContentItem("partsOrderedMessage") }}</p>
    <ul>
      <li v-for="(item, index) in relatedInvoices" :key="index">
        <router-link
          :to="{ name: 'InvoiceDetails', query: { invoiceId: item.Id, invoiceSource: item.InvoiceSource }}"
        >
          {{ item.InvoiceNumber }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "RelatedInvoices",
    computed: {
      ...mapGetters(["getContentItem"]),
      shouldRender: function() {
        return this.relatedInvoices && this.relatedInvoices.length > 0;
      }
    },
    props: {
      relatedInvoices: Array
    }
  };
</script>
